<!-- Título fijo -->
<h2 mat-dialog-title class="fds-title">
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ heading }}</span>
</h2>

<!-- Contenido scrolleable (el formulario proyectado) -->
<mat-dialog-content class="fds-content">
  <ng-content></ng-content>
</mat-dialog-content>

<!-- Acciones fijas -->
<mat-dialog-actions align="end" class="fds-actions">
  <button mat-button type="button" (click)="cancelled.emit()" [disabled]="saving">
    {{ cancelLabel }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="submit"
    [attr.form]="formId"
    [disabled]="saving || disabled"
    >
    <!-- Un solo nodo por rama: así el ícono/spinner cae en la posición de
         ícono del botón y queda alineado con el texto. -->
    @if (saving) {<mat-spinner diameter="18" matButtonIcon></mat-spinner>} @else {<mat-icon>{{ saveIcon }}</mat-icon>}
    <span>{{ saveLabel }}</span>
  </button>
</mat-dialog-actions>
